import React, { useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import { Button, TextField } from "@material-ui/core";
import CheckboxItem, { useStylesAcc } from "./CheckBoxComponent";
import { Autocomplete } from "@material-ui/lab";
import { GetItemFromOptions } from "../../../services/global-services";
import { useTranslation } from "react-i18next";

const applyDiscountOptionKeys = [
  // {id:0, name:"null"},
  {id:1, key:"discount-percent-only"},
  {id:2, key:"discount-amount-only"},
  {id:3, key:"discount-percent-and-amount"},
  
];
export default function DiscountPermissions(props) {
  const { onChange, object, update, sub } = props;
  const { t } = useTranslation(["forms"]);
  const applyDiscountOpeions = applyDiscountOptionKeys.map((option) => ({
    ...option,
    name: t(option.key),
  }));
  const applyDisc = GetItemFromOptions(object?.apply_discount, applyDiscountOpeions);

  const classes = useStylesAcc();

  return (
    <Grid item container spacing={1}>
    
          <Grid xs={6}>
          
          <CheckboxItem
                value={object["Disc_saleOnItem"] ?? null}
                name={"Disc_saleOnItem"}
                label={t("discount-on-item")}
                onChange={onChange}
              />
            </Grid>
          <Grid xs={6}>
            <CheckboxItem
                value={object["Disc_saleOnBills"] ?? null}
                name={"Disc_saleOnBills"}
                label={t("discount-on-invoice")}
                onChange={onChange}
              />
              
            </Grid>
            <Grid item xs={6} lg={4} md={4} sm={4}>
        <Autocomplete
          value={applyDisc}
          onChange={(event, newValue) => {
            onChange(null, {
              name: "apply_discount",
              value: newValue?.id,
            });
          }}
          id="apply_discount"
          size="small"
          options={applyDiscountOpeions}
          getOptionLabel={(option) =>
            typeof option === "string" ? option : option.name
          }
          style={{}}
          disableClearable
          renderInput={(params) => (
            <TextField
              {...params}
              InputLabelProps={{ shrink: true }}
              label={t("discount-type")}
              variant="outlined"
            />
          )}
        />
          </Grid>
          <Grid item xs={6} lg={4} md={4} sm={4}>
            <TextField
                  type="text"
                  fullWidth
                  variant="outlined"
                  size="small"
                  id="SaleDiscPers"
                  label={t("max-discount-percent")}
                  disabled={applyDisc?.id==2?true:false}
                  name="SaleDiscPers"
                  value={object?.SaleDiscPers}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => {
                    onChange(null, {
                      name: "SaleDiscPers",
                      value: e.target.value,
                      
                    });
                  }}
                />
          </Grid>
          <Grid item xs={6} lg={4} md={4} sm={4}>
            <TextField
                  type="text"
                  fullWidth
                  variant="outlined"
                  size="small"
                  id="SaleDiscValue"
                  label={t("max-discount-amount")}
                  // className={classes.textField}
                  name="SaleDiscValue"
                  disabled={applyDisc?.id==1?true:false}
                  value={object?.SaleDiscValue}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => {
                    onChange(null, {
                      name: "SaleDiscValue",
                      value: e.target.value,
                      
                    });
                  }}
                />
          </Grid>
  </Grid>
  );
}
